import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WorkerAgreementDetailsDto } from '../../../models/dtos/worker-agreement-details-dto';
import { AnnexPreviewService } from '../../services/annex-preview.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-agreement-annex-side-panel',
  templateUrl: './agreement-annex-side-panel.component.html',
  styleUrls: ['./agreement-annex-side-panel.component.scss'],
  providers: [AnnexPreviewService],
  standalone: false,
})
export class AgreementAnnexSidePanelComponent implements OnInit, OnDestroy {
  @Input() agreement: WorkerAgreementDetailsDto;
  @Input() splitId: string;
  @Input() annexPreviewService: AnnexPreviewService;

  pdfSrc: string = null;

  private previewSubscription: Subscription;

  constructor() {}

  ngOnInit(): void {
    this.previewSubscription = this.annexPreviewService.previewUpdate$.subscribe((blob) => {
      this.loadPdfFromBlob(blob);
    });
  }

  ngOnDestroy(): void {
    if (this.previewSubscription) {
      this.previewSubscription.unsubscribe();
    }

    if (this.pdfSrc) {
      URL.revokeObjectURL(this.pdfSrc);
    }
  }

  private loadPdfFromBlob(blob: Blob): void {
    if (this.pdfSrc) {
      URL.revokeObjectURL(this.pdfSrc);
    }

    this.pdfSrc = URL.createObjectURL(blob);
  }
}
